/* eslint-disable @typescript-eslint/no-useless-constructor */
import Header from "./Header";
import { Footer } from "./Footer";
import React, { useEffect } from "react";
import { useSeo } from "app/context/useSeo";
import ContextAlert from "shared/ui/Alert";
import { useUser } from "app/context/useUser";
import ContextModal from "shared/ui/Modal";
import { Heading } from "./Heading";

type Props = {
  children?: JSX.Element;
};
const Layout = (props: Props) => {
  const { user, set: setUserContext } = useUser();

  useEffect(() => {
    if (!user.sub) {
      setUserContext();
    }
  }, [setUserContext, user.sub]);

  const { h1 } = useSeo();
  return (
    <div className="app flex h-screen flex-col justify-between">
      <ContextAlert />
      <ContextModal />
      <Header />
      <div className="mx-auto my-10 w-screen max-w-screen-xl px-4">
        <Heading level={1}>{h1}</Heading>
        {props.children}
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
